import { render, staticRenderFns } from "./dischargeFollowUpDetail.vue?vue&type=template&id=963f4086&scoped=true"
import script from "./dischargeFollowUpDetail.vue?vue&type=script&lang=js"
export * from "./dischargeFollowUpDetail.vue?vue&type=script&lang=js"
import style0 from "./dischargeFollowUpDetail.vue?vue&type=style&index=0&id=963f4086&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963f4086",
  null
  
)

export default component.exports